export default {
  downtimeUrl: "https://it.kodland.tech",
  startPage: {
    title:
      "Cercasi ragazzi talentuosi per insegnare loro come creare i propri videogiochi, siti Web e programmi",
    subtitle:
      "Compila questo breve sondaggio e scrivetevi a una lezione individuale con un tutor di Kodland!",
    button: "Lo voglio gratis!🎁",
  },
  successPage: {
    title:
      "Perfetto! Vi chiediamo di scegliere un orario comodo per voi, per prenotare la vostra GRATUITA lezione. Affrettatevi a confermare la vostra presenza per una lezione con un tutor altamente qualificato 🚀",
    subtitle: 'Clicca su "📆 Prenota una lezione" per completare la registrazione',
    button: "📆 Prenota una lezione",
  },
  quizRotateBySteps: {
    1: {
      question: "Vorresti che il tempo che tuo figlio trascorre al computer sia più produttivo?",
      answers: ["💯 Sì!", "⌛️ No. È solo per divertimento va bene così"],
    },
    2: {
      title: "Qual è il nome di vostro figlio/a",
      type: "child_name",
      subtitle:
        "I tuoi dati personali sono al sicuro e possono essere cancellati in qualsiasi momento su richiesta🚨",
      button: "Avanti🎉",
    },
    3: {
      title: "Quanti anni ha il vostro figlio/a?",
      type: "age",
      subtitle: "Sceglieremo l'argomento della lezione più divertente in base all'età del figlio/a",
      button: "Avanti⭐️",
    },
    4: {
      question: "Qual è la materia preferita di tuo figlio/a a scuola?",
      answers: [
        "🔬 Scienza",
        "🎨 Arte e design",
        "💻 Informatica",
        "🏛️ Storia, letteratura",
        "📐 Matematica",
        "💬 Lingue straniere",
        "🤩 A loro piacciono tutte le materie",
        "🤔 Non ne sono sicuro",
      ],
    },
    5: {
      title: "Scegli l'orario della tua lezione introduttiva",
      type: "timeslot",
      subtitle:
        "Mancano solo pochi passaggi per la padronanza delle più moderne competenze tecnologiche di graphic design e sviluppo di videogiochi!🥳",
      button: "Voglio una lezione gratuita!🎁",
    },
    6: {
      title: "Qual è il vostro nome?",
      type: "parent_name",
      subtitle: "Il nostro nome è Kodland, qual è il vostro nome?👋",
      button: "Avanti🔥",
    },
    7: {
      question:
        "Vorresti che tuo figlio acquisisca una competenza professionale che possa essere dimostrata e utilizzata in futuro?",
      answers: ["🎉 Si!", "❌ No"],
    },
    8: {
      title: "Inserisci il vostro indirizzo e-mail",
      type: "mail",
      subtitle: "Non preoccupatevi, non verrà inviato alcuno spam😅",
      button: "Avanti⚡️",
    },
    9: {
      title: "Inserire il numero di telefono",
      type: "phone",
      subtitle: "Non ti chiameremo📞 Ci vediamo su messenger!",
      button: "quasi finito🥳",
    },
  },
};
